<template>
  <v-menu v-model="mostrar" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" class="mx-3">
        <v-icon
        color="secondary"> mdi-wrench-outline </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
      v-if="mixValidaScopesActions(1)"
      @click="cargarCatalogo" link>
        <v-list-item-icon>
          <v-icon
          color="secondary"> mdi-file-import </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> CARGAR CATÁLOGO </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <excel-catalogo
        :catalogoConceptos="catalogoConceptos"
        :contrato="contrato">
      </excel-catalogo>
      <v-list-item
      v-if="mixValidaScopesActions(2)"
      @click="actulizarCatalogo" link>
        <v-list-item-icon>
          <v-icon
          color="secondary"> mdi-reload </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> ACTUALIZAR </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-list>
  </v-menu>
</template>

<script>
import ExcelCatalogo from '@/components/exportar/exceles/ExcelCatalogoConceptos.vue';

export default {
  name: 'OpcionesCatalogoConceptos',
  props: {
    catalogoConceptos: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
  },
  components: {
    ExcelCatalogo,
  },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    cargarCatalogo() {
      this.$emit('cargarCatalogo');
    },
    actulizarCatalogo() {
      this.$emit('actualizarCatalogo');
    },
  },
};
</script>

<style lang="scss">
</style>
